import get from 'lodash/get'
import { getRelativePosition } from 'chart.js/helpers';

/**
* Chartjs plugin to add a configurable crosshair on mouse hover
* to any chart.
*
* See the chartjs plugin docs to better understand the API:
* https://www.chartjs.org/docs/developers/plugins.html
*
*/
export const crosshairPlugin = {
  id: 'crosshair',

  // Init the plugin with a "global" crosshair
  // object on the chart instance
  //
  // The canvasPosition will hold the current mouse/touch
  // position over the chart
  afterInit(chart) {
    chart.crosshair = {
      canvasPosition: null,
    }
  },

  // see: https://www.chartjs.org/docs/3.8.2/api/interfaces/Plugin.html#afterevent
  // The afterEvent hook will be used to recieve mouse/touch events
  // and update our "global state" to our mouse position
  afterEvent(chart, args) {
    const event = get(args, 'event', null)
    const eventType = get(event, 'type', [])
    const replay = get(args, 'replay', false)

    if ( eventType.includes('mousemove') && !replay) {
      // see: https://www.chartjs.org/docs/4.0.1/getting-started/integration.html#helper-functions
      const canvasPosition = getRelativePosition(event, chart)
      chart.crosshair.canvasPosition = canvasPosition
      chart.draw()
    } else if ( eventType.includes('mouseout') ) {
      // If the mouse moved off the chart,
      // redraw the chart without the crosshair
      chart.crosshair.canvasPosition = null
      chart.draw()
    }
  },

  // see: https://www.chartjs.org/docs/3.8.2/api/interfaces/Plugin.html#afterdraw
  afterDraw(chart, _args, options) {
    if (chart.crosshair.canvasPosition){
      const canvas = chart.ctx
      const maxY = chart.chartArea.bottom
      const canvasPosition = chart.crosshair.canvasPosition

      // Draw a vertical line on the chart at the mouse position
      // on the canvas
      canvas.beginPath();
      // canvas.setLineDash(options.dashPattern);
      canvas.moveTo(canvasPosition.x, 0);
      canvas.lineWidth = options.width;
      canvas.strokeStyle = options.color;
      canvas.lineTo(canvasPosition.x, maxY);
      canvas.stroke();
    }
  },

  // see: https://www.chartjs.org/docs/3.8.2/developers/plugins.html#plugin-defaults
  defaults: {
    width: 1,
    color: '#707090',
    dashPattern: [1, 1]
  }
}
